module.exports = __webpack_public_path__ + "img/operateur-expertise.a10dfc5e.jpg";